import { arraysHaveSameItems } from "@entrilia/shared/utilities/arrayHelper";
import { requiredValidator, type ValidationResult } from "@entrilia/shared/utilities/validators";
import type { ObjectClassDefinition, ObjectFeature } from "../../../../api/types/objectTypes";

export interface ObjectDefinitionGeneralForm {
  name: string;
  supportedFeatures: ObjectFeature[];
}

export interface ObjectDefinitionGeneralFormValidation {
  nameResult: ValidationResult;
  isValid: boolean;
}

export const getInitialObjectDefinitionGeneralForm = (
  objectDefinition: ObjectClassDefinition
): ObjectDefinitionGeneralForm => ({
  name: objectDefinition.objectName,
  supportedFeatures: objectDefinition.supportedFeatures,
});

export const isObjectDefinitionGeneralFormDirty = (
  form: ObjectDefinitionGeneralForm,
  objectDefinition: ObjectClassDefinition
) =>
  form.name.trim() !== objectDefinition.objectName.trim() ||
  !arraysHaveSameItems(form.supportedFeatures, objectDefinition.supportedFeatures);

export const validateObjectDefinitionGeneralForm = (
  form: ObjectDefinitionGeneralForm
): ObjectDefinitionGeneralFormValidation => {
  const nameResult = requiredValidator(form.name);
  const isValid = nameResult.isValid;
  return { nameResult, isValid };
};
